import withNavigate from '../../../core/withNavigate';
import { ShelfProducts } from '../../../components/products/products';
import categoriesApi from '../data/categories.api';

/**
 * Mimesa's Productos: the base page, with the product form's categories taken from Mimesa's
 * managed list (Categorías) instead of from the products already loaded, so the first product
 * can be created. Options show the category's name and store its key.
 */
export class MimesaProductsPage extends ShelfProducts {
    async initialize() {
        await super.initialize();
        if (!this.isAuthenticated) return;
        try {
            this.setState({ managedCategories: await categoriesApi.requestCategories() });
        } catch (error) {
            this.props.onMessage?.('error', error.message);
        }
    }

    get categoryOptions() {
        const managed = this.state.managedCategories || [];
        const options = managed.map((category) => ({ value: category.name, label: category.value }));
        // A product being edited keeps its category even if it was deactivated.
        const current = this.state.selectedProduct?.category;
        if (current && !options.some((option) => option.value === current)) options.push({ value: current, label: current });
        return options;
    }
}

export default withNavigate(MimesaProductsPage);
